/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'save': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M166 332h180c8.284 0 15-6.716 15-15s-6.716-15-15-15H166c-8.284 0-15 6.716-15 15s6.716 15 15 15zM166 392h180c8.284 0 15-6.716 15-15s-6.716-15-15-15H166c-8.284 0-15 6.716-15 15s6.716 15 15 15z"/><path pid="1" d="M507.606 84.394l-80-80A14.996 14.996 0 0 0 417 0H15C6.716 0 0 6.716 0 15v482c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15V95c0-3.979-1.581-7.794-4.394-10.606zM121 30h210v100H121V30zm270 452H121V272h270v210zm91 0h-61V257c0-8.284-6.716-15-15-15H106c-8.284 0-15 6.716-15 15v225H30V30h61v115c0 8.284 6.716 15 15 15h240c8.284 0 15-6.716 15-15V30h49.787L482 101.213V482z"/><path pid="2" d="M166 452h180c8.284 0 15-6.716 15-15s-6.716-15-15-15H166c-8.284 0-15 6.716-15 15s6.716 15 15 15z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/save.js